<template>
  <v-dialog
    v-model="dialog"
    persistent
    width="1000px"
    content-class="fm-dialog"
    @keydown.esc="fmClose"
  >
    <div v-show="contentLoaded">
      <file-manager class="content" />
    </div>

    <div
      class="content loader__bg align-center justify-center"
      :class="contentLoaded ? 'd-none' : 'd-flex'"
    >
      <v-progress-circular indeterminate color="primary" size="100" />
    </div>

    <div v-show="contentLoaded" class="fm-actions">
      <v-spacer />
      <v-btn
        depressed
        outlined
        color="primary"
        class="mr-4 my-2"
        @click="fmClose"
      >
        Отменить
      </v-btn>
      <v-btn
        depressed
        color="primary"
        class="mr-4 my-2"
        :disabled="(!selectedOne && !multiple) || (multiple && selectedZero)"
        @click="fmSet"
      >
        Выбрать
      </v-btn>
    </div>
  </v-dialog>
</template>

<script>
import FileManager from "@/fm/FileManager.vue";
import "./FileManagerDialog.scss";

export default {
  components: {
    FileManager
  },
  props: {
    value: {
      type: Boolean,
      required: true
    },
    selectedPath: {
      type: String,
      default: ""
    },
    workDir: {
      type: String,
      default: ""
    },
    src: {
      type: String,
      default: ""
    },
    multiple: {
      type: Boolean,
      default: false
    },
    allowedExtensions: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      foldersLoaded: false,
      contentLoaded: false,
      atata: 5
    };
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    },
    selectedFiles() {
      return this.$store.state.fm.left.selected.files;
    },
    selectedZero() {
      return this.selectedFiles.length == 0;
    },
    selectedOne() {
      return this.selectedFiles.length == 1;
    }
  },
  watch: {
    "$store.state.fm.tree.directories": function(directories) {
      if (!this.dialog) return;
      if (!this.foldersLoaded && directories.length) {
        this.foldersLoaded = true;
        this.changeDirAndSelectFile();
      } else if (this.foldersLoaded && !directories.length) {
        this.foldersLoaded = false;
      }
    },
    dialog: function(newVal) {
      if (newVal && this.foldersLoaded) {
        this.changeDirAndSelectFile();
      }
      if (!newVal) {
        this.contentLoaded = false;
      }
    }
  },
  methods: {
    fmClose() {
      this.$emit("fm-close");
    },
    fmSet() {
      if (this.allowedExtensions.length > 0) {
        for (const filePath of this.selectedFiles) {
          const matches = filePath.match(/\.(.+)$/);
          const ext = matches?.[1] || "";
          if (!this.allowedExtensions.includes(ext.toLowerCase())) {
            const extTypes = this.allowedExtensions.join(", ").toUpperCase();
            this.$store.commit("addNotice", {
              type: "error",
              message: `Тип файла ${ext.toUpperCase()} здесь не подойдёт. Выберите файл ${extTypes}.`
            });
            return false;
          }
        }
      }
      this.$emit(
        "fm-select",
        this.multiple ? this.selectedFiles : this.selectedFiles[0]
      );
    },
    getPathInfo() {
      if (this.selectedPath.length == 0) {
        return {
          dir:
            this.workDir.substring(0, 1) == "/"
              ? this.workDir.substring(1)
              : this.workDir,
          path: null
        };
      } else {
        const path = this.selectedPath.substring(1);
        const sepIndex = Math.max(
          path.lastIndexOf("/"),
          path.lastIndexOf("\\")
        );
        const dir = path.substring(0, sepIndex);
        return { dir, path };
      }
    },
    async changeDirAndSelectFile() {
      const { path, dir } = this.getPathInfo();

      if (dir) {
        await this.$store.dispatch(`fm/left/selectDirectory`, {
          path: `${dir}`,
          history: true
        });
      }
      if (path) {
        await this.$store.commit("fm/left/setSelected", {
          type: "files",
          path
        });
      }
      this.contentLoaded = true;
    }
  }
};
</script>
<style scoped lang="scss">
.content {
  height: 90vh;
}
.loader__bg {
  background-color: #fff;
}
</style>
